import React from 'react';

function ExportButton({ jobs }) {
  const exportToCSV = () => {
    const header = "ID,Tipo,Detalhes,Data\n";
    const csvData = jobs.map(row => row.join(',')).join('\n');
    const blob = new Blob([header + csvData], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'jobs.csv';
    a.click();
    window.URL.revokeObjectURL(url);
  };

  return <button className="btn-primary" style={{ padding: '0.5rem 1rem', fontSize: '0.8rem' }} onClick={exportToCSV}>Exportar CSV</button>;
}

export default ExportButton;
